"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StacksApiSocketClient = void 0;
const socket_io_client_1 = require("socket.io-client");
const runtime_1 = require("../generated/runtime");
function getWsUrl(url) {
    let urlObj;
    try {
        urlObj = new URL(url);
        if (!urlObj.protocol || !urlObj.host) {
            throw new TypeError(`[ERR_INVALID_URL]: Invalid URL: ${url}`);
        }
    }
    catch (error) {
        console.error(`Pass an absolute URL with a protocol/schema, e.g. "wss://example.com"`);
        throw error;
    }
    return urlObj;
}
class StacksApiSocketClient {
    constructor(socket) {
        this.socket = socket;
        this.logEvents();
    }
    static connect({ url = runtime_1.BASE_PATH, subscriptions = [], } = {}) {
        const socket = socket_io_client_1.io(getWsUrl(url).href, {
            query: {
                // Subscriptions can be specified on init using this handshake query param.
                subscriptions: Array.from(new Set(subscriptions)).join(','),
            },
        });
        return new StacksApiSocketClient(socket);
    }
    handleSubscription(topic, subscribe = false) {
        var _a, _b;
        const subscriptions = new Set((_b = (_a = this.socket.io.opts.query) === null || _a === void 0 ? void 0 : _a.subscriptions.split(',')) !== null && _b !== void 0 ? _b : []);
        if (subscribe) {
            this.socket.emit('subscribe', topic, error => {
                if (error)
                    console.error(`Error subscribing: ${error}`);
            });
            subscriptions.add(topic);
        }
        else {
            this.socket.emit('unsubscribe', topic);
            subscriptions.delete(topic);
        }
        // Update the subscriptions in the socket handshake so topics are persisted on re-connect.
        this.socket.io.opts.query.subscriptions = Array.from(subscriptions).join(',');
        return {
            unsubscribe: () => {
                this.handleSubscription(topic, false);
            },
        };
    }
    subscribeBlocks() {
        return this.handleSubscription('block', true);
    }
    unsubscribeBlocks() {
        this.handleSubscription('block', false);
    }
    subscribeMempool() {
        return this.handleSubscription('mempool', true);
    }
    unsubscribeMempool() {
        this.handleSubscription('mempool', false);
    }
    subscribeAddressTransactions(address) {
        return this.handleSubscription(`address-transaction:${address}`, true);
    }
    unsubscribeAddressTransactions(address) {
        this.handleSubscription(`address-transaction:${address}`, false);
    }
    subscribeAddressStxBalance(address) {
        return this.handleSubscription(`address-stx-balance:${address}`, true);
    }
    unsubscribeAddressStxBalance(address) {
        this.handleSubscription(`address-stx-balance:${address}`, false);
    }
    logEvents() {
        this.socket.on('connect', () => console.log('socket connected'));
        this.socket.on('disconnect', reason => console.warn('disconnected', reason));
        this.socket.on('connect_error', error => console.error('connect_error', error));
        this.socket.on('block', block => console.log('block', block));
        this.socket.on('mempool', tx => console.log('mempool', tx));
        this.socket.on('address-transaction', (address, data) => console.log('address-transaction', address, data));
        this.socket.on('address-stx-balance', (address, data) => console.log('address-stx-balance', address, data));
    }
}
exports.StacksApiSocketClient = StacksApiSocketClient;
//# sourceMappingURL=index.js.map